module.exports = __webpack_public_path__ + "static/media/quarantine.f4a6f79c.svg";